export { LocatorDetailPage } from './locator-detail-page';
